import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import { AuthService } from './auth.service';
import { MSG_LOGIN_EMAIL_SENHA, MSG_LOGIN_GOVBR_FALE_COM_RH } from 'src/app/tools/Mensagens';
import { URL, PAGINA_HOME, PAGINA_EXTERNAL_HOME, PAGINA_LOGIN, PAGINA_HOME_USUARIO_INTERNO, DENUNCIA} from 'src/app/tools/URL';
import { KeycloakService, KeycloakAuthGuard } from 'keycloak-angular';
import { CadastroUsuario } from 'src/app/entity/CadastroUsuario';
import { build } from 'src/build/build';

const CURRENT_USER = 'CurrentUser';
const PERMISSAO_NEGADA = 'Você não possui permissão para acessar essa página!';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService extends KeycloakAuthGuard implements CanActivate {

  constructor(private authService: AuthService, protected router: Router, protected keycloakService: KeycloakService) {

    super(router, keycloakService);

  }

  userAllowed(routeRoles: string[]) {

    return routeRoles === undefined ||
            routeRoles.length === 0 ||
            routeRoles.some(roleRota => this.keycloakService.isUserInRole(roleRota));

  }

  private routeRequiresGovBr(route: ActivatedRouteSnapshot): boolean {
    return route != null && route.data != null && route.data.requireGovBr === true;
  }

  private normalizarRota(path: string): string {
    const bruto = (path && path.length > 0 ? path : '').split('?')[0].split('#')[0];
    if (!bruto) {
      return '';
    }
    const semBarraFinal = bruto.replace(/\/+$/, '');
    if (!semBarraFinal) {
      return '/';
    }
    return semBarraFinal.startsWith('/') ? semBarraFinal : `/${semBarraFinal}`;
  }

  private isRotaFaleComRh(state: RouterStateSnapshot): boolean {
    const rota = this.normalizarRota(state && state.url ? state.url : '');
    const rotaFaleComRh = `/${URL.FALE_COM_RH}`;
    return rota === rotaFaleComRh || rota.startsWith(`${rotaFaleComRh}/`);
  }

  private rotaDestinoSemBarraInicial(state: RouterStateSnapshot): string {
    const rota = this.normalizarRota(state && state.url ? state.url : '');
    return rota.replace(/^\//, '');
  }

  private isTentativaFluxoGovBr(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const exigeGovBr = this.routeRequiresGovBr(route) || this.isRotaFaleComRh(state);
    if (exigeGovBr) {
      return true;
    }

    const redirecionamentoGovBr = this.authService.obterRedirecionamentoGovBr();
    return redirecionamentoGovBr === this.normalizarRota(state && state.url ? state.url : '');
  }

  isAccessAllowed(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

    return new Promise(async (resolve, reject) => {
      const autenticadoViaKeycloak = this.authenticated || this.authService.isAutenticadoViaKeycloak();

      const exigeGovBr = this.routeRequiresGovBr(route) || this.isRotaFaleComRh(state);

      if (exigeGovBr && !this.authService.isUsuarioGovBr()) {
        this.authService.definirRedirecionamentoGovBr(state.url);
        alert(MSG_LOGIN_GOVBR_FALE_COM_RH);
        this.router.navigate([PAGINA_LOGIN], { queryParams: { url: this.rotaDestinoSemBarraInicial(state) } });
        resolve(false);
        return false;
      }



      if (state.url === PAGINA_HOME) {

        this.keycloakService.isLoggedIn().then(logado => {

          if (logado) {
            this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);

          } else if (build.production) {
            window.open(PAGINA_EXTERNAL_HOME, '_self');

          }

          resolve(true);
          return true;

        });

      }

      const currentUser = localStorage.getItem(CURRENT_USER);

      if (currentUser) {

        const rolesUsuario = route.data.roles;

        const raw = currentUser;
        this.authService.usuarioDTO = raw ? JSON.parse(raw) : null;

        const allowed = this.userAllowed(route.data.roles);

        if (!allowed) {

          if (this.authService.isUsuarioExternoLogado()) {
            this.router.navigate([PAGINA_HOME]);

          } else if (this.roles.length === 0) {
            if (autenticadoViaKeycloak) {
              this.router.navigate([DENUNCIA]);
            } else {
              this.authService.logoutUser();
            }

          } else if(!this.validaRolesUsuarioLogado(rolesUsuario)){
            if (autenticadoViaKeycloak) {
              this.router.navigate([DENUNCIA]);
            } else {
              this.authService.logoutUserUsuarioInternoSemPermissao();
            }

          }else {
            this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);

          }

          reject(PERMISSAO_NEGADA);
          return allowed;

        }else{
           // Caso tenha permissão de acesso ao projeto, será verificada a situação das roles
          if(!this.isUsuarioExternoPorValidacao(rolesUsuario) && !this.validaRolesUsuarioLogado(rolesUsuario)){
            if (autenticadoViaKeycloak) {
              this.router.navigate([DENUNCIA]);
            } else {
              this.authService.logoutUserUsuarioInternoSemPermissao();
            }
          }
        }

        resolve(allowed);
        return allowed;

      } else if (this.authenticated) {

        this.authService.marcarAutenticacaoKeycloak();

        const rolesUsuario = route.data.roles;

        this.keycloakService.loadUserProfile().then(perfilKeycloak => {
          this.authService.usuarioDTO = new CadastroUsuario(perfilKeycloak);
          localStorage.setItem(CURRENT_USER, JSON.stringify(this.authService.usuarioDTO));
        });

        const allowed = this.userAllowed(route.data.roles);

        if (!allowed) {

          if (this.authService.isUsuarioExternoLogado()) {
            this.router.navigate([PAGINA_HOME]);

          } else if (this.roles.length === 0) {
            if (autenticadoViaKeycloak) {
              this.router.navigate([DENUNCIA]);//redirecionamento DEVSEI-486
            } else {
              this.authService.logoutUser();
            }

          } else if(!this.validaRolesUsuarioLogado(rolesUsuario)){
            if (autenticadoViaKeycloak) {
              this.router.navigate([DENUNCIA]);//redirecionamento DEVSEI-486
            } else {
              this.authService.logoutUserUsuarioInternoSemPermissao();
            }

          } else {
            this.router.navigate([PAGINA_HOME_USUARIO_INTERNO]);
          }

          reject(PERMISSAO_NEGADA);
          return allowed;

        }else{
          // Caso tenha permissão de acesso ao projeto, será verificada a situação das roles
          if(!this.isUsuarioExternoPorValidacao(rolesUsuario) && !this.validaRolesUsuarioLogado(rolesUsuario)){
            if (autenticadoViaKeycloak) {
              this.router.navigate([DENUNCIA]);//redirecionamento DEVSEI-486
            } else {
              this.authService.logoutUserUsuarioInternoSemPermissao();
            }
          }
        }

        resolve(allowed);
        return allowed;

      }

      if (this.isTentativaFluxoGovBr(route, state)) {
        alert(MSG_LOGIN_GOVBR_FALE_COM_RH);
      } else {
        alert(MSG_LOGIN_EMAIL_SENHA);
      }
      this.router.navigate([PAGINA_LOGIN], { queryParams: { url: this.rotaDestinoSemBarraInicial(state) } });

      reject(PERMISSAO_NEGADA);

    });

  }

  // Método que faz verificação das roles do usuário interno em relação as permissões
  validaRolesUsuarioLogado(rolesPermissaoAcesso: string[]) {

    try {
      const rolesUsuario = this.keycloakService.getUserRoles(); // retorna array de roles


      const isAcessoPermitidoRole: boolean = rolesPermissaoAcesso.some(role =>
        this.keycloakService.isUserInRole(role)
      );

      return isAcessoPermitidoRole != null ? isAcessoPermitidoRole : false;
    } catch (e) {
      console.error('AuthGuardService.validaRolesUsuarioLogado error', e);
      return false;
    }
  }

  // Método apenas para separar situação de quando usuário é externo, fazendo verificação a roles de acesso.
  isUsuarioExternoPorValidacao(routeRoles: string[]) {
    return routeRoles === undefined || routeRoles.length === 0 ;
  }

}
